import { useCallback } from 'react';
import { ConfirmationModal, useOverlayContext } from 'seagull';
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
import { CopyLinkForProposalModal } from "./CopyLinkForProposalModal";
import { jsx as _jsx } from "react/jsx-runtime";
export function useOpenCopyLinkModal() {
  const overlayContext = useOverlayContext();
  const openCopyLinkForAgreement = useCallback(function openCopyLinkModal(props) {
    const {
      testId,
      url
    } = props;
    return overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          title: "Copy link",
          content: /*#__PURE__*/_jsx(CopyToClipboard, {
            testId: testId,
            value: url
          }),
          primaryButtonLabel: "Close",
          onPrimaryButtonClick: dismissModal,
          onCloseButtonClick: dismissModal
        });
      }
    });
  }, []);
  const openCopyLinkForProposal = props => {
    const {
      testId,
      url,
      recipients
    } = props;
    if (recipients) {
      return overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/_jsx(ConfirmationModal, {
            width: '900px',
            title: "Copy link",
            content: /*#__PURE__*/_jsx(CopyLinkForProposalModal, {
              testId: testId,
              recipients: recipients
            }),
            primaryButtonLabel: "Close",
            onPrimaryButtonClick: dismissModal,
            onCloseButtonClick: dismissModal
          });
        }
      });
    } else if (url) {
      return openCopyLinkForAgreement({
        testId,
        url
      });
    }
  };
  return {
    openCopyLinkForAgreement,
    openCopyLinkForProposal
  };
}